import {useColorMode} from '../common/useColorMode';

export function ColorModeListener() {
  useColorMode();

  return null;
}
